import Checkbox from "@/components/Checkbox";
import {
  NewsFilter,
  updateNewsFilter,
} from "@/lib/redux/newsFilters/newsFiltersSlice";
import { useAppDispatch } from "@/lib/redux/hooks";
import Dropdown from "./Dropdown";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

type Props = {
  filter: NewsFilter;
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
};

const Selector: React.FC<Props> = (props) => {
  const { filter, isOpen, handleClose, handleOpen } = props;

  const dispatch = useAppDispatch();

  const isSelected = (value: string) => filter.selectedValues.includes(value);

  const handleChange = (value: string) => {
    const selectedValueSet = new Set(filter.selectedValues);
    if (isSelected(value)) {
      selectedValueSet.delete(value);
    } else {
      selectedValueSet.add(value);
    }
    dispatch(
      updateNewsFilter({
        id: filter.id,
        changes: {
          selectedValues: Array.from(selectedValueSet),
        },
      })
    );
  };

  const { locale = "it" } = useRouter();

  const t: Record<string, string | undefined> = {
    Year: useTranslation("newsPage.filters.year", locale),
    Category: useTranslation("investor.filters.category", locale),
  };

  return (
    <Dropdown
      label={t[filter.id] || filter.id}
      isOpen={isOpen}
      handleOpen={handleOpen}
      handleClose={handleClose}
    >
    {filter.values.map((value) => (
        <Checkbox
          key={value}
          value={value}
          checked={isSelected(value)}
          onChange={() => handleChange(value)}
        >
          {value.split(":")[0]}
        </Checkbox>
      )
    )}
    </Dropdown>
  );
};

export default Selector;
